import { useApiClient } from "../apiClients";
import { TRACKS_ENDPOINTS } from "./endpoints";
import type { Track } from "../../models/domain";

export type ListTracksParams = {
  grade_id: string;
  active_only?: boolean;
};

export type CreateTrackPayload = Omit<Track, "id" | "created_at" | "updated_at">;

export type UpdateTrackPayload = Partial<CreateTrackPayload>;

/** Filières d'un niveau : le catalogue est la seule source, rien en dur. */
export const useTracksApi = () => {
  const apiClient = useApiClient("embed");

  const listTracks = (params: ListTracksParams) =>
    apiClient.get<Track[]>(TRACKS_ENDPOINTS.BASE, { params });

  const getTrack = (trackId: string) =>
    apiClient.get<Track>(TRACKS_ENDPOINTS.DETAIL(trackId));

  const createTrack = (payload: CreateTrackPayload) =>
    apiClient.post<Track>(TRACKS_ENDPOINTS.BASE, payload);

  const updateTrack = (trackId: string, payload: UpdateTrackPayload) =>
    apiClient.put<Track>(TRACKS_ENDPOINTS.DETAIL(trackId), payload);

  const deleteTrack = (trackId: string) =>
    apiClient.delete<void>(TRACKS_ENDPOINTS.DETAIL(trackId));

  return { listTracks, getTrack, createTrack, updateTrack, deleteTrack };
};
